module.exports = __webpack_public_path__ + "img/dcf85a825ed63e44eb3991285627a122.png";